module.exports = __webpack_public_path__ + "static/img/Sharks.e7f518b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sharks.svg
// module id = WTOz
// module chunks = 1